





































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { get } from "../../api";
import InputRenderer from "./InputRenderer.vue";
import SampleTableActionRenderer from "./SampleTableActionRender.vue";
import SampleHeaderRenderer from "./SampleHeaderRenderer.vue";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import { PageConfig, ItemIssueConditionOptions } from "../../types";
import ProductTable from "../ProductTable.vue";

export default Vue.extend({
  components: {
    ProductTable
  },
  data(): { [key: string]: any } {
    return {
      selectedFinish: {},
      selectedSamples: [],
      deletedSamples: [],
      finishCode: "",
      finishSearchText: "",
      addingNewSample: false,
      haveToFetchSkuDetails: true,
      tableData: {
        columns: [
          {
            name: "sample_id",
            display_name: "Sample ID",
            fixed: false,
            width: 25,
            headrenderer: SampleHeaderRenderer,
            cellrenderer: InputRenderer
          },
          {
            name: "condition",
            display_name: "Condition",
            sortable: false,
            fixed: false,
            width: 30,
            headrenderer: SampleHeaderRenderer,
            cellrenderer: InputRenderer
          },
          {
            name: "location",
            display_name: "Location",
            fixed: false,
            width: 30,
            headrenderer: SampleHeaderRenderer,
            cellrenderer: InputRenderer
          },
          {
            name: "action",
            display_name: "",
            fixed: false,
            width: 15,
            headrenderer: SampleHeaderRenderer,
            cellrenderer: SampleTableActionRenderer
          }
        ]
      }
    };
  },
  provide(): any {
    return {
      actionHandler: this.handleTableAction,
      selectedSamplesGetter: this.getSelectedSamples
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      finishItem: "searchedProductSelected",
      samplesTableData: "inventorySampleDetails"
    }),
    finishesCount(): number {
      return this.filteredFinishes.length;
    },
    filteredFinishes(): any {
      return (this.finishItem.finishes || []).filter((item: any) =>
        item.displayName
          .toLowerCase()
          .includes(this.finishSearchText.toLowerCase())
      );
    }
  },
  methods: {
    ...mapActions("appModule", [
      "saveSwatchInventory",
      "getSelectedSearchProduct",
      "getInventorySamples",
      "getCmsProductSKUs"
    ]),
    handleFinishSelect(event: { item: { name: string; displayName: string } }) {
      this.finishItem.finishes = this.finishItem.finishes.map((item: any) => {
        if (item.name === event.item.name) {
          this.selectedFinish = item;
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      });
      //reset the pageConfig for the selectedFinish
      this.selectedFinish.samples.pageConfig = JSON.parse(
        JSON.stringify(PageConfig)
      );
      //fet the samples of the finish
      this.getSamples();
    },
    getSelectedSamples() {
      return this.selectedSamples;
    },
    handleTableAction(actionType: string, data: any) {
      let rowFoundIndexInSamples;
      let rowFoundIndex;
      if (data) {
        rowFoundIndex = this.selectedFinish.samples.data.findIndex(
          (rowItem: any) => {
            return rowItem.rowId === data.rowId;
          }
        );
      }
      switch (actionType) {
        case "delete":
          rowFoundIndexInSamples = this.findRowInSelectedSamples(
            this.selectedFinish.samples.data[rowFoundIndex].rowId
          );
          //if unique_code not equal to given by me then make is_deleted true and store.
          if (
            this.selectedFinish.samples.data[rowFoundIndex].sample_id !==
            this.selectedEc.name + "-" + this.selectedFinish.sku_code + "-XX"
          ) {
            this.selectedFinish.samples.data[rowFoundIndex].is_deleted = true;
            this.deletedSamples.push(
              this.selectedFinish.samples.data[rowFoundIndex]
            );
          }
          this.selectedFinish.samples.data.splice(rowFoundIndex, 1);
          this.selectedFinish.meta -= 1;
          break;
        case "edit":
          data.isEditing = true;
          break;
        case "header_checkbox":
          this.selectedSamples = [];
          this.selectedFinish.samples.data.forEach(
            (
              sample: { checked: boolean; status: string | null },
              index: number
            ) => {
              if (sample.status !== "ISSUED") {
                if (data) {
                  this.selectedSamples.push(sample);
                }
                sample.checked = data;
              }
            }
          );
          break;
        case "row_checkbox":
          rowFoundIndexInSamples = this.findRowInSelectedSamples(
            this.selectedFinish.samples.data[rowFoundIndex].rowId
          );
          if (rowFoundIndexInSamples < 0) {
            this.selectedSamples.push(
              this.selectedFinish.samples.data[rowFoundIndex]
            );
          }
          break;
        case "delete_selected":
          this.selectedFinish.samples.data = this.selectedFinish.samples.data.filter(
            (sample: any) => {
              if (
                sample.checked &&
                sample.sample_id !==
                  this.selectedEc.name +
                    "-" +
                    this.selectedFinish.sku_code +
                    "-XX"
              ) {
                sample.is_deleted = true;
                this.deletedSamples.push(sample);
              }
              return this.selectedSamples.indexOf(sample) === -1;
            }
          );
          this.selectedFinish.meta = this.selectedFinish.samples.data.length;
          this.selectedSamples = [];
          break;
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          this.selectedFinish.samples.pageConfig.offset =
            this.selectedFinish.samples.pageConfig.limit * (data - 1);
          this.selectedFinish.samples.pageConfig.page = data;
          this.getSamples();
          break;
        case "setPageLength":
          this.selectedFinish.samples.pageConfig.limit = data;
          this.selectedFinish.samples.pageConfig.page = 1;
          this.selectedFinish.samples.pageConfig.offset = 0;
          this.getSamples();
          break;
      }
    },
    addNewTableRowItem() {
      this.selectedFinish.samples.data.unshift({
        sample_id:
          this.selectedEc.name + "-" + this.selectedFinish.sku_code + "-XX",
        condition: { name: "", display_name: "" },
        location: "",
        action: null,
        is_deleted: false,
        isEditing: true,
        checked: false,
        rowId: this.selectedFinish.name + Math.ceil(Math.random() * 100000)
      });
      //update the meta of the selected finish
      (this.selectedFinish as any).meta += 1;
    },
    //search for the row in the list of samples
    findRowInSelectedSamples(rowId: string): number {
      const rowFoundIndexInSelectedSamples = this.selectedSamples.findIndex(
        (item: { rowId: string }) => {
          return item.rowId === rowId;
        }
      );
      if (rowFoundIndexInSelectedSamples > -1) {
        this.selectedSamples.splice(rowFoundIndexInSelectedSamples, 1);
      }
      return rowFoundIndexInSelectedSamples;
    },
    transformSaveInventoryRequest(): any {
      const transformedRequest = {
        inventory: [] as any[]
      };
      const saveSamples = this.selectedFinish.samples.data.concat(
        this.deletedSamples
      );
      const editSamples = saveSamples.filter((sample: any) => {
        if (sample.status && sample.status === "ISSUED") {
          return false;
        } else {
          return true;
        }
      });
      editSamples.forEach((sample: any) => {
        transformedRequest.inventory.push({
          ec_id: this.selectedEc.name,
          id: sample.id ? sample.id : null,
          sku_code: this.haveToFetchSkuDetails
            ? this.selectedFinish.sku_code
            : this.selectedFinish.name,
          sku_display_name: this.selectedFinish.displayName,
          name: this.finishItem.sku_name.name,
          condition: sample.condition.name,
          floor: sample.location,
          product_code: this.finishItem.sku_code,
          brand: this.finishItem.sku_name.brand,
          is_deleted: sample.is_deleted
        });
      });
      return transformedRequest;
    },
    saveInventory() {
      const saveRequest = this.transformSaveInventoryRequest();
      return this.saveSwatchInventory(saveRequest)
        .then((response: any) => {
          if (this.addingNewSample) {
            this.selectedFinish.samples.pageConfig.offset = PageConfig.offset;
            this.selectedFinish.samples.pageConfig.page = PageConfig.page;
          }
          this.$store.dispatch("uiModule/addToast", {
            severity: "success",
            message: this.addingNewSample
              ? "Samples added successfully"
              : "Samples updated successfully"
          });
          this.getSamples();
        })
        .catch((err: any) => {
          throw err;
        });
    },
    //fetch the skucode of the finish from CMS to be added in our inventory
    async fetchCmsProductSKUCode(
      productId: string | number,
      finish: { [key: string]: any }
    ) {
      const apiFilter = {
        filters: {
          field_options: finish.field_options
        }
      };
      const query = encodeQueryParams(apiFilter);
      const productSKU = await this.getCmsProductSKUs({
        query: query,
        productId: productId
      });
      return productSKU.code;
    },
    //to get the samples of the finish in our inventory of make it empty
    async getSamples() {
      if (this.haveToFetchSkuDetails) {
        this.selectedFinish.sku_code = await this.fetchCmsProductSKUCode(
          this.finishItem.productId,
          this.selectedFinish
        );
      }
      const query = {
        sku_code: this.haveToFetchSkuDetails
          ? this.selectedFinish.sku_code
          : this.finishCode,
        limit: this.selectedFinish.samples.pageConfig.limit,
        offset: this.selectedFinish.samples.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      this.selectedFinish.samples.pageConfig.query = encodeQueryParams(query);
      this.selectedFinish.samples = await this.getInventorySamples(
        this.selectedFinish.samples.pageConfig
      );
      if (this.selectedFinish.samples.data.length === 0) {
        this.addingNewSample = true;
      } else {
        this.addingNewSample = false;
      }
      this.selectedFinish.meta = this.selectedFinish.samples.pageConfig.totalcount;
    }
  },
  mounted() {
    //if finish item not found then take the user to the inventory page
    if (!this.finishItem) {
      this.$router.push({
        path: "/" + this.selectedEc.name + "/inventory"
      });
    }
    //when there is no finishes and samples
    if (this.finishItem.finishes.length === 0) {
      if (this.finishItem.default_sku) {
        this.finishItem.finishes = [
          {
            displayName: this.finishItem.default_sku.display_name,
            name: this.finishItem.default_sku.code,
            selected: true,
            meta: 0,
            subtext: this.finishItem.default_sku.code,
            imageurl: this.finishItem.sku_name.img_url,
            sku_code: this.finishItem.default_sku.code,
            samples: {
              data: [],
              pageConfig: JSON.parse(JSON.stringify(PageConfig))
            }
          }
        ];
        //enable this as we have to fetch the sku details for the finishes and pass that sku in save api
        this.haveToFetchSkuDetails = false;
      }
    }
    this.selectedFinish = this.finishItem.finishes[0];
    this.selectedFinish.selected = true;
    if (this.$router.currentRoute.params.skuCode) {
      this.finishCode = this.$router.currentRoute.params.skuCode;
      //if coming from edit then don't need to fetch the sku details
      this.haveToFetchSkuDetails = false;
    } else {
      this.finishCode = this.selectedFinish.name;
    }
    this.getSamples();
  }
});
